// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__32b-p","title":"ClientReferral_title__1a9Y7","itemText":"ClientReferral_itemText__18cMv"};